import LayautContext from 'Context/ContextLayaut';
import { useContext } from 'react';

const ServicioAsignacion = () => {
    const context = useContext(LayautContext);
    return {
        getAsignacionesInt: context.llamarServidor('Curso/getAsignacionesInt'),
        updateAsignacion: context.llamarServidorRespuesta('Curso/updateAsignacion'),
        cambiarEstatusAsignacion: context.llamarServidorRespuesta('Curso/cambiarEstatusAsignacion')
    };
};

export default ServicioAsignacion;
